import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

import styles from './Indicator.scss';

export default function Indicator({ white, orientation, text, useOverlay }) {
    const rootStyles = {};

    if (white) {
        rootStyles.color = '#fff';
    }

    if (orientation === 'middle') {
        rootStyles.height = '100%';
        rootStyles.width = '100%';
        rootStyles.position = 'absolute';
        rootStyles.top = 0;
        rootStyles.left = 0;
    }

    return (
        <div
            className={styles.container}
            data-item="loading-indicator"
            style={rootStyles}
        >
            {useOverlay && <div className={styles.overlay} />}
            <span className={styles[`orientation-${orientation}`]}>
                {!!text && !!text.length && <span className={styles.text}>
                    {text}
                </span>}
                <span data-spinner className={styles.spinner} />
            </span>
        </div>
    );
}

Indicator.displayName = displayName('LoadingIndicator/Indicator');

Indicator.propTypes = {
    orientation: PropTypes.string,
    text: PropTypes.string,
    useOverlay: PropTypes.bool,
    white: PropTypes.bool,
};

Indicator.defaultProps = {
    orientation: '',
    text: '',
    useOverlay: false,
    white: false,
};
